"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksOrderPostAsyncSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../api/index.js");
const actions_1 = require("../../_idMap/actions.js");
const effects_1 = require("redux-saga/effects");
const name = 'CoreInitiativesTasksOrder';
exports.coreInitiativesTasksOrderPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [
            ({ initiativeId, sourceIndex, targetIndex }) => (0, actions_1.updateInitiativeReferences)([
                {
                    initiativeId,
                    tasks: {
                        toReorderByIndex: {
                            sourceIndex,
                            targetIndex
                        }
                    }
                }
            ])
        ]
    },
    name,
    receive: false,
    request: true,
    requestHandler: function* requestHandler(request) {
        var _a;
        const tasks = ((_a = (yield (0, effects_1.select)((state) => { var _a; return (_a = state.core.initiatives.byIdMap.data[request.initiativeId]) === null || _a === void 0 ? void 0 : _a.tasks; }))) !== null && _a !== void 0 ? _a : []);
        return yield (0, effects_1.call)(_api_1.postInitiativeTaskOrder, {
            initiativeId: request.initiativeId,
            initiativeTaskOrder: tasks.map(({ initiativeTaskId, orderIndex }) => ({
                initiativeTaskId,
                orderIndex
            }))
        });
    }
});
//# sourceMappingURL=post.js.map